import React from 'react';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';

// utils
import { i18nKeys } from '@/src/utils/i18n.utils';

export interface IQuitConfirmModal {
  message: string;
  visible: boolean;
  onOkClick: () => void;
  onDismiss: () => void;
}

const { okText, cancelText, title } = i18nKeys.eventTemplates.quitModal;

export const QuitConfirmModal: React.FC<IQuitConfirmModal> = ({ message, visible, onOkClick, onDismiss }) => {
  const { t } = useTranslation();

  return (
    <Modal
      onDismiss={onDismiss}
      closeAriaLabel={t(i18nKeys.general.close)}
      visible={visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button id="cancel-button" data-testid="cancel-button" onClick={onDismiss}>
              {t(cancelText)}
            </Button>
            <Button variant="primary" id="leave-button" data-testid="leave-button" onClick={onOkClick}>
              {t(okText)}
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={t(title)}
    >
      {t(message)}
    </Modal>
  );
};
